import * as AppleAuthentication from 'expo-apple-authentication';
import React from 'react';
import { TouchableOpacity, Text, Platform, ActivityIndicator, View } from 'react-native';

interface AppleSignInButtonProps {
  onPress: () => void;
  loading: boolean;
  onPressIn?: () => void;
  onPressOut?: () => void;
  socialScale?: number;
  style?: any;
}

const AppleSignInButton: React.FC<AppleSignInButtonProps> = ({
  onPress,
  loading,
  onPressIn,
  onPressOut,
  socialScale = 1,
  style
}) => {
  // On iOS, use the native Apple Authentication button for App Store compliance
  // and proper iPad popover presentation handling
  if (Platform.OS === 'ios') {
    return (
      <View style={[{
        transform: [{ scale: socialScale }],
        opacity: loading ? 0.5 : 1,
      }, style]}>
        <AppleAuthentication.AppleAuthenticationButton
          buttonType={AppleAuthentication.AppleAuthenticationButtonType.CONTINUE}
          buttonStyle={AppleAuthentication.AppleAuthenticationButtonStyle.BLACK}
          cornerRadius={40}
          style={{
            width: '100%',
            height: 56,
          }}
          onPress={onPress}
        />
        {loading && (
          <ActivityIndicator
            size="small"
            color="#FFFFFF"
            style={{
              position: 'absolute',
              right: 24,
              top: 0,
              bottom: 0,
              justifyContent: 'center',
            }}
          />
        )}
      </View>
    );
  }

  // For web/Android, keep the custom button
  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={loading}
      activeOpacity={0.8}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      style={[{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#1D1A23',
        borderRadius: 40,
        paddingVertical: 16,
        paddingHorizontal: 24,
        transform: [{ scale: socialScale }],
        ...Platform.select({
          web: {
            boxShadow: '0 2px 12px 0 rgba(29, 26, 35, 0.08)',
            transitionProperty: 'box-shadow, transform, opacity',
            transitionDuration: '200ms'
          },
          android: {
            elevation: 4,
          }
        })
      }, loading && { opacity: 0.5 }, style]}
    >
      <Text style={{
        fontSize: 18,
        backgroundColor: '#FFFFFF',
        color: '#1D1A23',
        width: 24,
        height: 24,
        textAlign: 'center',
        lineHeight: 24,
        borderRadius: 12,
        marginRight: 8,
        overflow: 'hidden',
      }}>
        {'\uF8FF'}
      </Text>
      <Text style={{
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: '600',
        letterSpacing: 0.3
      }}>
        {loading ? 'Connecting...' : 'CONTINUE WITH APPLE'}
      </Text>
      {loading && (
        <ActivityIndicator
          size="small"
          color="#FFFFFF"
          style={{
            position: 'absolute',
            right: 24,
            top: '50%',
            marginTop: -10
          }}
        />
      )}
    </TouchableOpacity>
  );
};

export default AppleSignInButton;
